/* eslint @typescript-eslint/no-var-requires: "off" */
/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    totem: {
      waitingDialog: {
        show: false
      },
      state: 'disconnected'
    },
    mediaAccess: null,
    locale: 'es',
    channel: 'video',
    channelIsSet: false,
    viewer: {},
    activeCall: false,
    parentLocation: {
      origin: null,
      organizationCode: null
    },
    categorySettings: {
      call: true,
      calendar: true
    },
    unSafeDomains: [],
    rooms: {
      list: {
        data: [],
        loading: false
      },
      item: {
        data: {
          _id: null,
          mux_stream: {
            stream_id: null,
            key_stream: null,
            playback_id: null
          },
          title: "",
          description: "",
          posts: [],
          postsIds: [],
          terms: [],
          live: false,
          forbiddenWords: []
        },
        views: 0,
        updating: false,
        loading: false,
        chat: {
          uuid: null,
          unreadMessages: false,
          messages: [],
          config: {
            visible: false
          }
        },
        viewer: {
          _id: null
        }
      }
    },
    organization: {
      cammersAvailable: [],
      cammerAvailableGroupByCategory: [],
      loading: false,
      item: {
        id: null,
        uuid: null,
        name: null,
        brand: 'https://ocular-prod.s3.us-east-2.amazonaws.com/brand/1/ocular-brand.jpg',
        host_name: null,
        show_service: true,
        attending: true,
        primaryColor: '#C754CC',
        organization_configs: [],
        widget: {
          widget_attributes: []
        }
      },
      error: <any>null
    },
    widget: {
      uuid: null,
      loading: false,
      onfocus: false,
      activeCall: false,
      isBusy: false,
      mainPath: null,
      osMediaDevicesPermissions: true,
      embedMode: false,
      maximized: false,
      error: <any>null,
      orientation: '',
      code: <any>null,
      data: {
        organization: {
          id: null,
          uuid: null
        },
        uuid: null,
        brand: 'https://ocular-prod.s3.us-east-2.amazonaws.com/brand/1/ocular-brand.jpg',
        name: null,
        title: null,
        description: null,
        banner: null,
        attributes: [],
        configs: []
      }
    },
    questionnary: {
      loading: false,
      item: <any> null,
      geoip: {
        location_country_iso_code: null,
        location_country_name: null,
        network: null
      }
    },
    calendar: {
      schedule: '',
      events: {
        loading: false,
        list: <any>[]
      },
      availableHours: {
        loading: false,
        list: <any>[],
        group: <any>null,
        date: <any>null,
        selected: <any>null
      },
      scheduledEvents: {
        loading: false,
        item: <any>null,
        response: <any>null,
        error: <any>null
      }
    },
    httpRequest: {
      loading: false,
      item: <any>null,
      response: <any>null,
      error: <any>null
    },
    call: {
      createCall: {
        loading: false,
        response: <any>null,
        error: <any>null
      },
      awaitingCammer: {
        loading: false,
        response: <any>null,
        error: <any>null
      },
      availableActions: <any>null
    },
    storage: <any> {
      room: {
        customer: null
      }
    },
    queue: {
      position: null,
      isAlive: true,
      data: <any> null
    },
    support: {
      OT: {
        shareScreen: false,
        codec: 'VP8'
      }
    },
    cookieEnabled: null,
    lobbySession: <any>null,
    linkSession: <any>null,
    ping: {
      code: null
    },
    videoProcessor: {
      backgroundFilter: <any>null,
      colorFilter: <any>null,
      nsfwDetection: false,
      nsfwLastEvent: <any>null
    },
    signal: {
      msg: false,
      file: false,
      img: false,
      video: false
    },
    services: {
      storage: {
        completed: false
      }
    },
    testConnectivity: {
      progress: false,
      mbps: null
    },
    snackbar: {
      show: false,
      timeout: 5000,
      color: 'light',
      message: ''
    },
    zohoLead: {
      id: null
    }
  },
  mutations: {
    SET_ACTIVE_CALL (state, active) {
      state.widget.activeCall = active
    },
    SET_ATTENTION_CHANNEL (state, channel) {
      state.channel = channel
      state.channelIsSet = true
    },
    SET_TOTEM_WAITING_DIALOG_SHOW (state, show) {
      state.totem.waitingDialog.show = show
    },
    SET_QUESTIONNAIRE_ITEM (state, item) {
      item.questions.map((question: any) => {
        question.filteredAnswers = question.parent_id ? [] : question.answers
        question.show = true

        return question
      })
      state.questionnary.item = item
    },
    SET_QUESTIONNAIRE_QUESTION_SHOW (state, { questionId, show }) {
      const question = state.questionnary.item.questions.find((question: any) => question.id === questionId)
      if (question) {
        question.show = show
      }
    },
    SET_QUESTIONNAIRE_QUESTION_FILTERED_ANSWERS (state, { questionId, answers }) {
      const question = state.questionnary.item.questions.find((question: any) => question.id === questionId)
      if (question) {
        question.filteredAnswers = answers
      }
    },
    SET_STORAGE_ROOM_CUSTOMER (state, data) {
      state.storage.room.customer = data
    },
    SET_MEDIA_ACCESS (state, data) {
      state.mediaAccess = data
    },
    SET_TOTEM_STATE (state, totemState) {
      state.totem.state = totemState
    },
    notify (state, data) {
      state.snackbar.message = data.message
      state.snackbar.color = data.color
      state.snackbar.show = true
    },
    setCammersAvailable (state, data) {
      state.organization.cammersAvailable = data
    },
    setCammersAvailableGroupByCategory (state, data) {
      state.organization.cammerAvailableGroupByCategory = data
    },
    setZohoLeadId (state, data) {
      state.zohoLead.id = data.id
    },
    SET_VIDEO_PROCESSOR_BACKGROUND (state: any, filter: any) {
      state.videoProcessor.backgroundFilter = filter
    },
    SET_VIDEO_PROCESSOR_COLOR (state: any, filter: any) {
      state.videoProcessor.colorFilter = filter
    },
    SET_VIDEO_PROCESSOR_NSFW (state: any, active: boolean) {
      state.videoProcessor.nsfwDetection = active
    },
    SET_VIDEO_PROCESSOR_NSFW_EVENT (state: any, event: any) {
      state.videoProcessor.nsfwLastEvent = event
    }
  },
  actions: {
    setAttentionChannel ({ commit }, channel) {
      commit('SET_ATTENTION_CHANNEL', channel)
    },
    setTotemWaitingDialogShow ({ commit }, show) {
      commit('SET_TOTEM_WAITING_DIALOG_SHOW', show)
    },
    setQuestionnaireItem ({ commit }, item) {
      commit('SET_QUESTIONNAIRE_ITEM', item)
    },
    setQuestionnaireQuestionFilteredAnswers({ commit, state }, payload) {
      const { questionId, answers } = payload;
      commit('SET_QUESTIONNAIRE_QUESTION_FILTERED_ANSWERS', { questionId, answers });
    },
    setQuestionnaireQuestionShow ({ commit }, { questionId, show }) {
      commit('SET_QUESTIONNAIRE_QUESTION_SHOW', { questionId, show })
    },
    setStorageRoomCustomer ({ commit }, data) {
      commit('SET_STORAGE_ROOM_CUSTOMER', data)
    },
    setMediaAccess ({ commit }, data) {
      commit('SET_MEDIA_ACCESS', data)
    },
    setTotemState ({ commit }, totemState) {
      commit('SET_TOTEM_STATE', totemState)
    }
  },
  modules: {
  }
})
